var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlideRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 35,
    viewBox: "0 0 20 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.96314 0.69261L19.4931 16.2071C19.6774 16.3918 19.8077 16.5919 19.8839 16.8074C19.9613 17.0229 20 17.2537 20 17.5C20 17.7463 19.9613 17.9771 19.8839 18.1926C19.8077 18.4081 19.6774 18.6082 19.4931 18.7929L3.96313 34.3536C3.53303 34.7845 2.99539 35 2.35023 35C1.70507 35 1.15207 34.7691 0.691244 34.3074C0.230414 33.8456 1.48011e-07 33.3069 2.01834e-07 32.6913C2.55656e-07 32.0756 0.230414 31.5369 0.691244 31.0752L14.2396 17.5L0.691247 3.9248C0.26114 3.49384 0.0460843 2.96315 0.0460844 2.33272C0.0460845 1.70105 0.2765 1.15435 0.737329 0.69261C1.19816 0.230868 1.73579 -1.59671e-06 2.35023 -1.54299e-06C2.96467 -1.48928e-06 3.50231 0.230868 3.96314 0.69261Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlideRight);
export default __webpack_public_path__ + "static/media/slide-right.6a1c092c241fbc09c290d1c51d898c01.svg";
export { ForwardRef as ReactComponent };